import AppleTouchIconPngUrl from "@iyk/ui/assets/apple-touch-icon.png?url"
import FaviconIcoUrl from "@iyk/ui/assets/favicon.ico?url"
import FaviconSvgUrl from "@iyk/ui/assets/favicon.svg?url"

export const Assets = {
  images: {
    AppleTouchIconPngUrl,
    FaviconIcoUrl,
    FaviconSvgUrl,
    worldIdPlaceholderImage: "https://assets.iyk.app/music/ui/world-id/placeholder-world-image.png"
  },
  documents: {
    privacyPolicyUrl: "https://assets.iyk.app/iyk-privacy-policy.pdf",
    termsOfServiceUrl: "https://assets.iyk.app/iyk-terms-of-service.pdf"
  }
}
